module.exports = __webpack_public_path__ + "img/193-Gris Noir Structur‚.jpg";